import { render, staticRenderFns } from "./SearchWS.vue?vue&type=template&id=7a8b9368&"
import script from "./SearchWS.vue?vue&type=script&lang=js&"
export * from "./SearchWS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports